<template>
  <div class="aiAssistantBasicForm">
    <el-row :gutter="24">
      <el-col :span="12">
        <el-form-item label="roleName（角色名称）" prop="jsonConfig.aiRole.name" data-field-key="roleName">
          <el-input v-model="ruleForm.jsonConfig.aiRole.name" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="model" prop="jsonConfig.llmModel" data-field-key="llmModel">
          <el-select
            v-model="ruleForm.jsonConfig.llmModel"
            style="width: 100%;"
            placeholder="请选择"
            filterable
            allow-create
          >
            <el-option label="gpt-4.1-nano(推荐)" value="gpt-4.1-nano" />
            <el-option label="gemini-3-flash" value="gemini-3-flash" />
            <el-option label="deepseek/deepseek-chat-v3.1" value="deepseek/deepseek-chat-v3.1" />
            <el-option label="deepseek-chat-v3" value="deepseek-chat-v3" />
            <el-option label="deepseek-chat-v3-0324" value="deepseek-chat-v3-0324" />
            <el-option label="gpt-4o-mini" value="gpt-4o-mini" />
          </el-select>
        </el-form-item>
        <el-form-item label="prompt" prop="jsonConfig.prompt[0].content" data-field-key="prompt">
          <el-input
            v-model="ruleForm.jsonConfig.prompt[0].content"
            type="textarea"
            :rows="4"
            placeholder="请输入 system prompt"
          />
        </el-form-item>
        <el-form-item label="introduction">
          <el-input
            v-model="ruleForm.jsonConfig.aiRole.introduction"
            type="textarea"
            :rows="3"
            placeholder="请输入 introduction"
          />
        </el-form-item>
        <el-form-item label="describe">
          <el-input
            v-model="ruleForm.jsonConfig.aiRole.describe"
            type="textarea"
            :rows="3"
            placeholder="请输入 describe"
          />
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <div class="aiAssistantBasicForm__mediaGrid">
          <el-form-item label="avatar" prop="jsonConfig.aiRole.avatar" data-field-key="avatar">
            <div class="aiAssistantUploadTile">
              <el-upload
                action=""
                :show-file-list="false"
                :http-request="(params) => uploadImage(params, 'avatar')"
              >
                <template v-if="ruleForm.jsonConfig.aiRole.avatar">
                  <img :src="ruleForm.jsonConfig.aiRole.avatar" class="aiAssistantUploadTile__img" alt="">
                  <i
                    class="el-icon-error aiAssistantUploadTile__clear"
                    @click.stop="clearImage('avatar')"
                  />
                </template>
                <i v-else class="el-icon-plus aiAssistantUploadTile__plus" />
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="bgL">
            <div class="aiAssistantUploadTile">
              <el-upload
                action=""
                :show-file-list="false"
                :http-request="(params) => uploadImage(params, 'bgL')"
              >
                <template v-if="ruleForm.jsonConfig.aiRole.bgL">
                  <img :src="ruleForm.jsonConfig.aiRole.bgL" class="aiAssistantUploadTile__img" alt="">
                  <i class="el-icon-error aiAssistantUploadTile__clear" @click.stop="clearImage('bgL')" />
                </template>
                <i v-else class="el-icon-plus aiAssistantUploadTile__plus" />
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="bgS">
            <div class="aiAssistantUploadTile">
              <el-upload
                action=""
                :show-file-list="false"
                :http-request="(params) => uploadImage(params, 'bgS')"
              >
                <template v-if="ruleForm.jsonConfig.aiRole.bgS">
                  <img :src="ruleForm.jsonConfig.aiRole.bgS" class="aiAssistantUploadTile__img" alt="">
                  <i class="el-icon-error aiAssistantUploadTile__clear" @click.stop="clearImage('bgS')" />
                </template>
                <i v-else class="el-icon-plus aiAssistantUploadTile__plus" />
              </el-upload>
            </div>
          </el-form-item>
        </div>

        <el-form-item label="welcome">
          <div class="aiAssistantBasicForm__tagList">
            <el-tag
              v-for="(tag, index) in ruleForm.jsonConfig.aiRole.welcome"
              :key="'welcome-' + index"
              closable
              @close="deleteListTag('welcome', index)"
            >
              {{ tag }}
            </el-tag>
          </div>
          <el-input
            v-if="welcomeInputVisible"
            ref="saveWelcomeTagInput"
            v-model="welcomeInputValue"
            size="small"
            style="width: 220px;"
            placeholder="输入后回车"
            @keyup.enter.native="handleWelcomeInputConfirm"
            @blur="handleWelcomeInputConfirm"
          />
          <el-button
            v-else-if="canAddWelcome"
            size="small"
            @click="showWelcomeInput"
          >
            + 添加 welcome
          </el-button>
          <span class="aiAssistantBasicForm__tagHint">
            最多 {{ listMax }} 条（{{ ruleForm.jsonConfig.aiRole.welcome.length }}/{{ listMax }}）
          </span>
        </el-form-item>

        <el-form-item label="starters">
          <div class="aiAssistantBasicForm__tagList">
            <el-tag
              v-for="(tag, index) in ruleForm.jsonConfig.aiRole.starters"
              :key="'starters-' + index"
              closable
              @close="deleteListTag('starters', index)"
            >
              {{ tag }}
            </el-tag>
          </div>
          <el-input
            v-if="startersInputVisible"
            ref="saveStartersTagInput"
            v-model="startersInputValue"
            size="small"
            style="width: 220px;"
            placeholder="输入后回车"
            @keyup.enter.native="handleStartersInputConfirm"
            @blur="handleStartersInputConfirm"
          />
          <el-button
            v-else-if="canAddStarters"
            size="small"
            @click="showStartersInput"
          >
            + 添加 starters
          </el-button>
          <span class="aiAssistantBasicForm__tagHint">
            最多 {{ listMax }} 条（{{ ruleForm.jsonConfig.aiRole.starters.length }}/{{ listMax }}）
          </span>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { uploadFile } from '../../../../../api/comment'
import { AI_ASSISTANT_ROLE_LIST_MAX } from '../../../aiAssistantManage/aiAssistantConstants'
import basicFormMixin from './basicFormMixin'

export default {
  name: 'AiAssistantBasicForm',
  mixins: [basicFormMixin],
  props: {
    ruleForm: { type: Object, required: true },
  },
  data() {
    return {
      welcomeInputVisible: false,
      welcomeInputValue: '',
      startersInputVisible: false,
      startersInputValue: '',
      listMax: AI_ASSISTANT_ROLE_LIST_MAX,
    }
  },
  computed: {
    canAddWelcome() {
      return (this.ruleForm.jsonConfig.aiRole.welcome || []).length < this.listMax
    },
    canAddStarters() {
      return (this.ruleForm.jsonConfig.aiRole.starters || []).length < this.listMax
    },
  },
  methods: {
    uploadImage(params, key) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadFile(formData)
        .then((res) => {
          this.ruleForm.jsonConfig.aiRole[key] = res.data
          if (key === 'avatar') {
            this.ruleForm.thumbUrl = res.data
          }
        })
        .catch((err) => {
          this.$message.error(err || '上传失败')
        })
    },
    clearImage(key) {
      this.ruleForm.jsonConfig.aiRole[key] = ''
      if (key === 'avatar') {
        this.ruleForm.thumbUrl = ''
      }
    },
    deleteListTag(field, index) {
      this.ruleForm.jsonConfig.aiRole[field].splice(index, 1)
    },
    confirmListTag(field, inputValue, inputVisibleKey, inputValueKey) {
      const text = String(inputValue || '').trim()
      const list = this.ruleForm.jsonConfig.aiRole[field] || []
      if (text) {
        if (list.length >= this.listMax) {
          this.$message.warning(`${field} 最多 ${this.listMax} 条`)
        } else {
          list.push(text)
        }
      }
      this[inputVisibleKey] = false
      this[inputValueKey] = ''
    },
    handleWelcomeInputConfirm() {
      this.confirmListTag(
        'welcome',
        this.welcomeInputValue,
        'welcomeInputVisible',
        'welcomeInputValue'
      )
    },
    showWelcomeInput() {
      if (!this.canAddWelcome) {
        this.$message.warning(`welcome 最多 ${this.listMax} 条`)
        return
      }
      this.welcomeInputVisible = true
      this.$nextTick(() => {
        const ref = this.$refs.saveWelcomeTagInput
        if (ref && ref.$refs.input) {
          ref.$refs.input.focus()
        }
      })
    },
    handleStartersInputConfirm() {
      this.confirmListTag(
        'starters',
        this.startersInputValue,
        'startersInputVisible',
        'startersInputValue'
      )
    },
    showStartersInput() {
      if (!this.canAddStarters) {
        this.$message.warning(`starters 最多 ${this.listMax} 条`)
        return
      }
      this.startersInputVisible = true
      this.$nextTick(() => {
        const ref = this.$refs.saveStartersTagInput
        if (ref && ref.$refs.input) {
          ref.$refs.input.focus()
        }
      })
    },
    validate() {
      const jsonConfig = this.ruleForm.jsonConfig || {}
      const aiRole = jsonConfig.aiRole || {}
      const prompt = Array.isArray(jsonConfig.prompt) ? jsonConfig.prompt[0] : null
      if (!String(aiRole.name || '').trim()) {
        return Promise.reject('请填写角色名称')
      }
      if (!String(jsonConfig.llmModel || '').trim()) {
        return Promise.reject('请选择 Model')
      }
      if (!String((prompt && prompt.content) || '').trim()) {
        return Promise.reject('请填写 Prompt')
      }
      if (!String(aiRole.avatar || '').trim()) {
        return Promise.reject('请上传 Avatar')
      }
      return Promise.resolve()
    },
    captureSnapshot() {
      const jsonConfig = this.ruleForm.jsonConfig || {}
      const aiRole = jsonConfig.aiRole || {}
      return {
        roleName: aiRole.name,
        llmModel: jsonConfig.llmModel,
        prompt: jsonConfig.prompt && jsonConfig.prompt[0] && jsonConfig.prompt[0].content,
        avatar: aiRole.avatar,
        welcome: Array.isArray(aiRole.welcome) ? aiRole.welcome.join('|') : '',
        starters: Array.isArray(aiRole.starters) ? aiRole.starters.join('|') : '',
      }
    },
  },
}
</script>

<style scoped>
.aiAssistantBasicForm__mediaGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
}

.aiAssistantBasicForm__tagList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.aiAssistantBasicForm__tagHint {
  display: inline-block;
  margin-left: 8px;
  font-size: 12px;
  color: var(--link-ink-muted, #7a746c);
}

.aiAssistantBasicForm >>> .aiAssistantUploadTile .el-upload {
  border: 1px dashed var(--link-line-strong, #d9d9d9);
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: visible;
}

.aiAssistantBasicForm >>> .aiAssistantUploadTile__plus {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.aiAssistantBasicForm >>> .aiAssistantUploadTile__img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

.aiAssistantBasicForm >>> .aiAssistantUploadTile__clear {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #f56c6c;
  font-size: 18px;
  cursor: pointer;
}
</style>
